// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2WX0e","title":"AfterFrontImage_title__vSbPK"};